<mat-form-field floatLabel="never"
  class="common-text-box date-control {{ defaultHeight ? 'height-40' : 'height-32' }}"
  [ngClass]="{'nr-err-border': formGroup.get(formControlFieldName).touched && 
    formGroup.get(formControlFieldName).hasError('required') ||
    formGroup.get(formControlFieldName).hasError('future') ||
    formGroup.get(formControlFieldName).hasError('past'),'nr-disabled': isReadonlyCls}">
  <input [ngClass]="defaultHeight ? 'height-40' : 'height-32'" matInput [matDatepicker]="dp"
    id="{{formControlFieldName}}" formControlName="{{formControlFieldName}}" placeholder="{{placeholder}}"
    [readonly]="isReadonly" [min]="minDate" [max]="maxDate" [maxlength]="mxLength"
    onkeypress="return event.charCode >= 48 && event.charCode <= 57" autocomplete="off"
    (blur)="validateSelected($event)"/>
  <mat-datepicker-toggle matSuffix [for]="dp"  tabindex="-1"></mat-datepicker-toggle>
  <mat-datepicker #dp (closed)="onClose()" [disabled]="isReadonly"></mat-datepicker>
</mat-form-field>